module.exports = __webpack_public_path__ + "static/img/product8.149511ec.png";